import { connect } from 'react-redux';
import FilterProfileDetails from './FilterProfileDetails';
import {
  deleteFilterProfile,
  loadFilterProfiles,
  saveFilterProfile,
  saveFilterProfileLocally,
  updateFilterProfile,
  applyFilters,
  changeFilterProfileScope,
  changeFilterProfileName,
  loadSpecificFilter,
  resetSpecificFilter,
  loadTagOptions,
  autoCompleteTagOptions,
  resetTagOptions,
  changeSelectedFilterProfile,
  resetSelectedFilterProfile,
  openCreateNewAdvancedFilter,
  openEditAdvancedFilter,
  toggleFilterSidebar,
  closeFilterSidebar,
} from '../../redux/actions/filters';
import { updateDistinct } from '../../redux/actions/ioc';
import {
  selectFilterIndicators,
  selectOptionsByIndicator,
} from '../../redux/selectors/filters';
import { loadMySubscriptionPlan } from '../../redux/actions/user';
import { changeTitle } from '../../redux/actions/app';

const mapStateToProps = (state) => {
  return {
    availableFilterProfiles: state.filter.profiles,
    originalFilterProfiles: state.filter.originalFilterProfiles,
    dropdownSelectedProfile: state.filter.dropdownSelectedProfile,
    appliedFilterProfile: state.filter.selectedProfile,
    originalAppliedFilterProfile: state.filter.appliedProfile,

    mySubscriptionPlan: state.user.mySubscriptionPlan,
    activeThreatRankingEndpoint: state.ioc.activeThreatRankingEndpoint,
    endpointParams: state.ioc.endpointParams,
    paginationStatus: state.ioc.paginationStatus,
    profilesLoadStatus: state.filter.profilesLoadStatus,
    indicatorsMap: state.ioc.filterSettings?.indicatorsMap,
    filterIndicators: selectFilterIndicators(state),
    optionsByIndicator: selectOptionsByIndicator(state),
    specificFilterIndicator: state.ioc.specificFilterSettings,
    specificFilterSettingsStatus: state.ioc.specificFilterSettingsStatus,
    tagOptions: state.ioc.tagOptions,
    tagOptionsStatus: state.ioc.tagOptionsStatus,
    status: state.ioc.status,
    user: state.user.user,
    deleteProfileStatus: state.filter.deleteProfileStatus,
    profilesUpdateStatus: state.filter.profilesUpdateStatus,
    filterSidebarOpen: state.sidebar.advancedFilterMenuOpen,
    filterSidebarStatus: state.sidebar.sideBarStatus,
    profileChangedNameStatus: state.filter.profileChangedNameStatus,

    //filterSettingsStatus: state.ioc.filterSettingsStatus,
  };
};

const mapDispatchToProps = {
  loadSpecificFilter,
  resetSpecificFilter,
  loadTagOptions,
  autoCompleteTagOptions,
  resetTagOptions,
  deleteFilterProfile,
  loadFilterProfiles,
  saveFilterProfile,
  saveFilterProfileLocally,
  changeFilterProfileScope,
  changeFilterProfileName,
  updateFilterProfile,
  applyFilters,
  updateDistinct,
  loadMySubscriptionPlan,
  changeTitle,
  changeSelectedFilterProfile,
  resetSelectedFilterProfile,
  openCreateNewAdvancedFilter,
  openEditAdvancedFilter,
  toggleFilterSidebar,
  closeFilterSidebar,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterProfileDetails);
